var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "css-ivry7e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94 19.574C7.612 21.19 9.806 22 12 22c2.194 0 4.387-.809 6.061-2.426 3.347-3.236 3.347-8.48 0-11.716L12.001 2 5.938 7.858c-3.347 3.235-3.347 8.48 0 11.716z",
    fill: "url(#hot-g_svg__paint0_linear_1330_2334)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.506 18.544A4.911 4.911 0 0012 20a4.91 4.91 0 003.494-1.456 4.992 4.992 0 000-7.03L12 8l-3.494 3.515a4.991 4.991 0 000 7.03z",
    fill: "#76808F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.5L5.5 6 8 3.5 5.5 1 3 3.5z",
    fill: "url(#hot-g_svg__paint1_linear_1330_2334)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.5L21.5 9 23 7.5 21.5 6 20 7.5z",
    fill: "#76808F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20l1.5 1.5L4 20l-1.5-1.5L1 20z",
    fill: "url(#hot-g_svg__paint2_linear_1330_2334)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hot-g_svg__paint0_linear_1330_2334",
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hot-g_svg__paint1_linear_1330_2334",
    x1: 5.5,
    y1: 6,
    x2: 5.5,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hot-g_svg__paint2_linear_1330_2334",
    x1: 2.5,
    y1: 21.5,
    x2: 2.5,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/popular.99323137a7d290087b9a631d83d4f4cb.svg";
export { ForwardRef as ReactComponent };